var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGraduationCap = function SvgGraduationCap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M22.5 26.2a15 15 0 0 0 2-1.062V30a1 1 0 0 1-2 0zm-7.387-14.675a1.025 1.025 0 0 0 .412 1.363L21.375 16l2.125-1.137-7.025-3.75a1.025 1.025 0 0 0-1.362.412m16.362-.412-15-8a1.06 1.06 0 0 0-.95 0l-15 8a1.012 1.012 0 0 0 0 1.775L3.5 14.463v6.225c-.002.429.139.847.4 1.187C4.888 23.2 8.688 27.5 16 27.5a16.1 16.1 0 0 0 6.5-1.312V16.6l-1.125-.6L16 18.863 4.975 12.988 3.125 12 16 5.138 28.875 12l-1.85.988-3.525 1.875.475.25c.17.097.308.24.4.412A.94.94 0 0 1 24.5 16v9.138a14 14 0 0 0 3.6-3.263c.261-.34.402-.758.4-1.187v-6.225l2.975-1.575a1.013 1.013 0 0 0 0-1.775"
  })));
};
export default SvgGraduationCap;